"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatchHeight = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _utils = require("acq-utils/lib/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MatchHeight = exports.MatchHeight = /*#__PURE__*/function (_React$Component) {
  _inherits(MatchHeight, _React$Component);
  var _super = _createSuper(MatchHeight);
  function MatchHeight(props) {
    var _this;
    _classCallCheck(this, MatchHeight);
    _this = _super.call(this, props);
    _this.state = {
      height: false
    };
    _this.handleResize = (0, _lodash["default"])(_this.handleResize.bind(_assertThisInitialized(_this)), 200);
    return _this;
  }
  _createClass(MatchHeight, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.handleScreenSizeChange) {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
      }
      this.unsubscribe = this.context.matchHeight.subscribe({
        name: this.props.name,
        callback: function callback(height) {
          _this2.setState({
            height: height
          });
        }
      });
      this.reportHeight(this.getClientHeight());
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (this.props.handleScreenSizeChange) {
        if (this.state.height === false || prevProps.name !== this.props.name) {
          this.unsubscribe = this.context.matchHeight.subscribe({
            name: this.props.name,
            callback: function callback(height) {
              _this3.setState({
                height: height
              });
            }
          });
          this.reportHeight(this.getClientHeight());
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('orientationchange', this.handleResize);
      this.unsubscribe();
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      // persist old state
      var oldHeight = this.node.style.height;
      // temp set it to auto
      this.node.style.height = 'auto';
      // read the natural height
      var clientHeight = this.node.offsetHeight;
      // set it back to old style
      this.node.style.height = oldHeight;
      return clientHeight;
    }

    /* istanbul ignore next */
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.setState({
        height: false
      });
    }
  }, {
    key: "reportHeight",
    value: function reportHeight(clientHeight) {
      var height = clientHeight;
      /*
        Ryan Hinchey - 7/25/18
        there's a bug in Safari 10 when reporting offsetHeight
        offsetHeight, clientHeight and getBoundingClientRect report higher than expected
        this is the best hack I can find to keep welcome-offer content aligned on Safari 10
      */
      /* istanbul ignore next */
      if ((0, _utils.isSafari)(window.navigator) && this.props.name === 'welcome-offer') {
        if ((0, _utils.browserVersion)(window.navigator) === 10) {
          height /= 1.5;
        }
      }
      this.context.matchHeight.reportHeight(this.props.name, height);
    }
  }, {
    key: "validateHeightAfterReRender",
    value: function validateHeightAfterReRender() {
      var _this4 = this;
      // This is only an issue when doing Client Side Navigation
      // we need the timeout or else we wont get the latest height
      setTimeout(function () {
        var clientHeight = _this4.node && _this4.getClientHeight();
        /* istanbul ignore next */
        if (_this4.state.height < clientHeight) {
          _this4.reportHeight(clientHeight);
        }
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var style = _objectSpread({}, this.props.style);
      this.validateHeightAfterReRender();
      if (this.state.height) style.height = "".concat(this.state.height, "px");
      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        className: this.props.className,
        ref: function ref(node) {
          _this5.node = node;
        }
      }, children);
    }
  }]);
  return MatchHeight;
}(_react["default"].Component);
_defineProperty(MatchHeight, "contextTypes", {
  matchHeight: _propTypes["default"].object
});
_defineProperty(MatchHeight, "propTypes", {
  name: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  handleScreenSizeChange: _propTypes["default"].bool
});
_defineProperty(MatchHeight, "defaultProps", {
  className: '',
  style: {},
  handleScreenSizeChange: false
});